const configIos = [
  {
      "id": 1,
      "value": "手Q1区-苍天翔龙"
  },
  {
      "id": 2,
      "value": "手Q2区-铁血都督"
  },
  {
      "id": 3,
      "value": "手Q3区-野蛮之锤"
  },
  {
      "id": 4,
      "value": "手Q4区-正义爆轰"
  },
  {
      "id": 5,
      "value": "手Q5区-机关造物"
  },
  {
      "id": 6,
      "value": "手Q6区-名士狂歌"
  },
  {
      "id": 7,
      "value": "手Q7区-致命灵药"
  },
  {
      "id": 8,
      "value": "手Q8区-不死之炎"
  },
  {
      "id": 9,
      "value": "手Q9区-生命主宰"
  },
  {
      "id": 10,
      "value": "手Q10区-反击之镰"
  },
  {
      "id": 11,
      "value": "手Q11区-血之回响"
  },
  {
      "id": 12,
      "value": "手Q12区-死神之镰"
  },
  {
      "id": 13,
      "value": "手Q13区-二天一流"
  },
  {
      "id": 14,
      "value": "手Q14区-永生之血"
  },
  {
      "id": 15,
      "value": "手Q15区-君临天地"
  },
  {
      "id": 16,
      "value": "手Q16区-渴望之血"
  },
  {
      "id": 17,
      "value": "手Q17区-欲望之月"
  },
  {
      "id": 18,
      "value": "手Q18区-运筹帷幄"
  },
  {
      "id": 19,
      "value": "手Q19区-东风来袭"
  },
  {
      "id": 20,
      "value": "手Q20区-谋略法球"
  },
  {
      "id": 21,
      "value": "手Q21区-八卦阵列"
  },
  {
      "id": 22,
      "value": "手Q22区-叹息激流"
  },
  {
      "id": 23,
      "value": "手Q23区-乱世争霸"
  },
  {
      "id": 24,
      "value": "手Q24区-霸道之刃"
  },
  {
      "id": 25,
      "value": "手Q25区-纵横天下"
  },
  {
      "id": 26,
      "value": "手Q26区-浴血枭雄"
  },
  {
      "id": 27,
      "value": "手Q27区-陷阵之志"
  },
  {
      "id": 28,
      "value": "手Q28区-霸王之斩"
  },
  {
      "id": 29,
      "value": "手Q29区-回旋打击"
  },
  {
      "id": 30,
      "value": "手Q30区-影子杀手"
  },
  {
      "id": 31,
      "value": "手Q31区-勇气幻盾"
  },
  {
      "id": 32,
      "value": "手Q32区-复仇箴言"
  },
  {
      "id": 33,
      "value": "手Q33区-激昂猛攻"
  },
  {
      "id": 34,
      "value": "手Q34区-风怒结界"
  },
  {
      "id": 35,
      "value": "手Q35区-突进白刃"
  },
  {
      "id": 36,
      "value": "手Q36区-狂乱奔流"
  },
  {
      "id": 37,
      "value": "手Q37区-崩坏意志"
  },
  {
      "id": 38,
      "value": "手Q38区-贯穿破甲"
  },
  {
      "id": 39,
      "value": "手Q39区-元气再生"
  },
  {
      "id": 40,
      "value": "手Q40区-神速瞬影"
  },
  {
      "id": 41,
      "value": "手Q41区-乱舞心火"
  },
  {
      "id": 42,
      "value": "手Q42区-致命凋零"
  },
  {
      "id": 43,
      "value": "手Q43区-信念绽放"
  },
  {
      "id": 44,
      "value": "手Q44区-野性潜能"
  },
  {
      "id": 45,
      "value": "手Q45区-警戒迷雾"
  },
  {
      "id": 46,
      "value": "手Q46区-生机振奋"
  },
  {
      "id": 47,
      "value": "手Q47区-无畏铁躯"
  },
  {
      "id": 48,
      "value": "手Q48区-庇佑沙漏"
  },
  {
      "id": 49,
      "value": "手Q49区-奇袭冲锋"
  },
  {
      "id": 50,
      "value": "手Q50区-痛苦狙击"
  },
  {
      "id": 51,
      "value": "手Q51区-正义清算"
  },
  {
      "id": 52,
      "value": "手Q52区-风暴滋生"
  },
  {
      "id": 53,
      "value": "手Q53区-灵感复苏"
  },
  {
      "id": 54,
      "value": "手Q54区-传送之扉"
  },
  {
      "id": 55,
      "value": "手Q55区-净化共鸣"
  },
  {
      "id": 56,
      "value": "手Q56区-狂热煞气"
  },
  {
      "id": 57,
      "value": "手Q57区-暴戾气数"
  },
  {
      "id": 58,
      "value": "手Q58区-傲慢戒律"
  },
  {
      "id": 59,
      "value": "手Q59区-阳炎回声"
  },
  {
      "id": 60,
      "value": "手Q60区-弧光静默"
  },
  {
      "id": 61,
      "value": "手Q61区-刹那处决"
  },
  {
      "id": 62,
      "value": "手Q62区-睿智升华"
  },
  {
      "id": 63,
      "value": "手Q63区-暴走冲锋"
  },
  {
      "id": 64,
      "value": "手Q64区-锐利鹰眼"
  },
  {
      "id": 65,
      "value": "手Q65区-灵山献祭"
  },
  {
      "id": 66,
      "value": "手Q66区-地狱岩魂"
  },
  {
      "id": 67,
      "value": "手Q67区-白执事"
  },
  {
      "id": 68,
      "value": "手Q68区-女仆咖啡"
  },
  {
      "id": 69,
      "value": "手Q69区-夺宝奇兵"
  },
  {
      "id": 70,
      "value": "手Q70区-驱魔猎手"
  },
  {
      "id": 71,
      "value": "手Q71区-异域舞娘"
  },
  {
      "id": 72,
      "value": "手Q72区-迷城魅影"
  },
  {
      "id": 73,
      "value": "手Q73区-剑舞者"
  },
  {
      "id": 74,
      "value": "手Q74区-死亡骑士"
  },
  {
      "id": 75,
      "value": "手Q75区-精灵之王"
  },
  {
      "id": 76,
      "value": "手Q76区-破晓极意"
  },
  {
      "id": 77,
      "value": "手Q77区-隐袭幻杀"
  },
  {
      "id": 78,
      "value": "手Q78区-炙热剑芒"
  },
  {
      "id": 79,
      "value": "手Q79区-赤月冲击"
  },
  {
      "id": 80,
      "value": "手Q80区-燎原箭雨"
  },
  {
      "id": 81,
      "value": "手Q81区-假面骑士"
  },
  {
      "id": 82,
      "value": "手Q82区-夜巡之灵"
  },
  {
      "id": 83,
      "value": "手Q83区-贤者试炼"
  },
  {
      "id": 84,
      "value": "手Q84区-绝代歌姬"
  },
  {
      "id": 85,
      "value": "手Q85区-阴阳谋者"
  },
  {
      "id": 86,
      "value": "手Q86区-奇异博士"
  },
  {
      "id": 87,
      "value": "手Q87区-暗影刺客"
  },
  {
      "id": 88,
      "value": "手Q88区-易装侍郎"
  },
  {
      "id": 89,
      "value": "手Q89区-双枪游侠"
  },
  {
      "id": 90,
      "value": "手Q90区-魔道宗师"
  },
  {
      "id": 91,
      "value": "手Q91区-青春永驻"
  },
  {
      "id": 92,
      "value": "手Q92区-绝对力量"
  },
  {
      "id": 93,
      "value": "手Q93区-元气炮弹"
  },
  {
      "id": 94,
      "value": "手Q94区-吉凶卜兆"
  },
  {
      "id": 95,
      "value": "手Q95区-碎星卦象"
  },
  {
      "id": 96,
      "value": "手Q96区-不死之花"
  },
  {
      "id": 97,
      "value": "手Q97区-无尽轮回"
  },
  {
      "id": 98,
      "value": "手Q98区-鼓舞之盾"
  },
  {
      "id": 99,
      "value": "手Q99区-死神怜悯"
  },
  {
      "id": 100,
      "value": "手Q100区-红月吟诵"
  },
  {
      "id": 101,
      "value": "手Q101区-长安之鬼"
  },
  {
      "id": 102,
      "value": "手Q102区-玉石广场"
  },
  {
      "id": 103,
      "value": "手Q103区-益城往事"
  },
  {
      "id": 104,
      "value": "手Q104区-渭水之都"
  },
  {
      "id": 105,
      "value": "手Q105区-敦煌故卷"
  },
  {
      "id": 106,
      "value": "手Q106区-沧海桑田"
  },
  {
      "id": 107,
      "value": "手Q107区-峡谷勇士"
  },
  {
      "id": 108,
      "value": "手Q108区-长乐教坊"
  },
  {
      "id": 109,
      "value": "手Q109区-醉卧雁帐"
  },
  {
      "id": 110,
      "value": "手Q110区-稷下桃源"
  },
  {
      "id": 111,
      "value": "手Q111区-黑猫糖果"
  },
  {
      "id": 112,
      "value": "手Q112区-花见巫女"
  },
  {
      "id": 113,
      "value": "手Q113区-极冰防御"
  },
  {
      "id": 114,
      "value": "手Q114区-午夜歌剧"
  },
  {
      "id": 115,
      "value": "手Q115区-无间傀儡"
  },
  {
      "id": 116,
      "value": "手Q116区-美梦成真"
  },
  {
      "id": 117,
      "value": "手Q117区-命运角斗"
  },
  {
      "id": 118,
      "value": "手Q118区-御狮之名"
  },
  {
      "id": 119,
      "value": "手Q119区-绝影神枪"
  },
  {
      "id": 120,
      "value": "手Q120区-爱与和平"
  },
  {
      "id": 121,
      "value": "手Q121区-追影者"
  },
  {
      "id": 122,
      "value": "手Q122区-午后时光"
  },
  {
      "id": 123,
      "value": "手Q123区-铸梦破空"
  },
  {
      "id": 124,
      "value": "手Q124区-炽阳烈刃"
  },
  {
      "id": 125,
      "value": "手Q125区-日落孤枪"
  },
  {
      "id": 126,
      "value": "手Q126区-高山流水"
  },
  {
      "id": 127,
      "value": "手Q127区-飓风起航"
  },
  {
      "id": 128,
      "value": "手Q128区-唤灵魔甲"
  },
  {
      "id": 129,
      "value": "手Q129区-指尖交响"
  },
  {
      "id": 130,
      "value": "手Q130区-枫霜尽"
  },
  {
      "id": 131,
      "value": "手Q131区-知音绝弦"
  },
  {
      "id": 132,
      "value": "手Q132区-瀚海图兰"
  },
  {
      "id": 133,
      "value": "手Q133区-幻梦朔月"
  },
  {
      "id": 134,
      "value": "手Q134区-时之愿境"
  },
  {
      "id": 135,
      "value": "手Q135区-掠影金秋"
  },
  {
      "id": 136,
      "value": "手Q136区-远古战歌"
  },
  {
      "id": 137,
      "value": "手Q137区-炽焰浑天"
  },
  {
      "id": 138,
      "value": "手Q138区-昼夜轮转"
  },
  {
      "id": 139,
      "value": "手Q139区-万国盛会"
  },
  {
      "id": 140,
      "value": "手Q140区-花朝为约"
  },
  {
      "id": 141,
      "value": "手Q141区-风飒木萧"
  },
  {
      "id": 142,
      "value": "手Q142区-无双福将"
  },
  {
      "id": 143,
      "value": "手Q143区-响遏行云"
  },
  {
      "id": 144,
      "value": "手Q144区-无心人偶"
  },
  {
      "id": 145,
      "value": "手Q145区-七芒连星"
  },
  {
      "id": 146,
      "value": "手Q146区-潮玩牛仔"
  },
  {
      "id": 147,
      "value": "手Q147区-芙蓉金铃"
  },
  {
      "id": 148,
      "value": "手Q148区-侠者之道"
  },
  {
      "id": 149,
      "value": "手Q149区-秋杏破空"
  },
  {
      "id": 150,
      "value": "手Q150区-凤栖梧桐"
  },
  {
      "id": 151,
      "value": "手Q151区-剑光樽影"
  },
  {
      "id": 152,
      "value": "手Q152区-悬寂长夜"
  },
  {
      "id": 153,
      "value": "手Q153区-一击决胜"
  },
  {
      "id": 154,
      "value": "手Q154区-箭无虚发"
  },
  {
      "id": 155,
      "value": "手Q155区-绝地救援"
  },
  {
      "id": 156,
      "value": "手Q156区-舞弄清影"
  },
  {
      "id": 157,
      "value": "手Q157区-群星辉映"
  },
  {
      "id": 158,
      "value": "手Q158区-羽纱笼萤"
  },
  {
      "id": 159,
      "value": "手Q159区-惊雷启蛰"
  },
  {
      "id": 160,
      "value": "手Q160区-曙光乍现"
  },
  {
      "id": 161,
      "value": "手Q161区-梦笔生花"
  },
  {
      "id": 162,
      "value": "手Q162区-陨落遗迹"
  },
  {
      "id": 163,
      "value": "手Q163区-剑圣本心"
  },
  {
      "id": 164,
      "value": "手Q164区-祈雪灵祝"
  },
  {
      "id": 165,
      "value": "手Q165区-啸动山林"
  },
  {
      "id": 166,
      "value": "手Q166区-破暗逐明"
  },
  {
      "id": 167,
      "value": "手Q167区-鲸落云海"
  },
  {
      "id": 168,
      "value": "手Q168区-黄沙幻蝶"
  },
  {
      "id": 169,
      "value": "手Q169区-淬剑出征"
  },
  {
      "id": 170,
      "value": "手Q170区-亘古不息"
  }
]
const configA = [
    {
        "id": 1,
        "value": "手Q1区-王者独尊"
    },
    {
        "id": 2,
        "value": "手Q2区-绝代智谋"
    },
    {
        "id": 3,
        "value": "手Q3区-不羁之风"
    },
    {
        "id": 4,
        "value": "手Q4区-千金重弩"
    },
    {
        "id": 5,
        "value": "手Q5区-死亡绽放"
    },
    {
        "id": 6,
        "value": "手Q6区-最终兵器"
    },
    {
        "id": 7,
        "value": "手Q7区-叛逆吟游"
    },
    {
        "id": 8,
        "value": "手Q8区-暴走机关"
    },
    {
        "id": 9,
        "value": "手Q9区-欲望之月"
    },
    {
        "id": 10,
        "value": "手Q10区-风华绚烂"
    },
    {
        "id": 11,
        "value": "手Q11区-逍遥幻梦"
    },
    {
        "id": 12,
        "value": "手Q12区-恋之微风"
    },
    {
        "id": 13,
        "value": "手Q13区-和平守望"
    },
    {
        "id": 14,
        "value": "手Q14区-苍天龙鸣"
    },
    {
        "id": 15,
        "value": "手Q15区-天翔之龙"
    },
    {
        "id": 16,
        "value": "手Q16区-破云之龙"
    },
    {
        "id": 17,
        "value": "手Q17区-惊雷之龙"
    },
    {
        "id": 18,
        "value": "手Q18区-友情守护"
    },
    {
        "id": 19,
        "value": "手Q19区-豪情突进"
    },
    {
        "id": 20,
        "value": "手Q20区-激情迸发"
    },
    {
        "id": 21,
        "value": "手Q21区-正义豪腕"
    },
    {
        "id": 22,
        "value": "手Q22区-治愈微笑"
    },
    {
        "id": 23,
        "value": "手Q23区-绽放之舞"
    },
    {
        "id": 24,
        "value": "手Q24区-甜蜜恋风"
    },
    {
        "id": 25,
        "value": "手Q25区-星华缭乱"
    },
    {
        "id": 26,
        "value": "手Q26区-兼爱非攻"
    },
    {
        "id": 27,
        "value": "手Q27区-和平漫步"
    },
    {
        "id": 28,
        "value": "手Q28区-机关重炮"
    },
    {
        "id": 29,
        "value": "手Q29区-墨守成规"
    },
    {
        "id": 30,
        "value": "手Q30区-活力迸发"
    },
    {
        "id": 31,
        "value": "手Q31区-翻滚突袭"
    },
    {
        "id": 32,
        "value": "手Q32区-红莲爆弹"
    },
    {
        "id": 33,
        "value": "手Q33区-究极弩炮"
    },
    {
        "id": 34,
        "value": "手Q34区-诛心剑雨"
    },
    {
        "id": 35,
        "value": "手Q35区-灵魂冲击"
    },
    {
        "id": 36,
        "value": "手Q36区-偶像魅力"
    },
    {
        "id": 37,
        "value": "手Q37区-女王崇拜"
    },
    {
        "id": 38,
        "value": "手Q38区-王朝密令"
    },
    {
        "id": 39,
        "value": "手Q39区-圣光守护"
    },
    {
        "id": 40,
        "value": "手Q40区-誓约之盾"
    },
    {
        "id": 41,
        "value": "手Q41区-回旋打击"
    },
    {
        "id": 42,
        "value": "手Q42区-圣剑裁决"
    },
    {
        "id": 43,
        "value": "手Q43区-迟缓之箭"
    },
    {
        "id": 44,
        "value": "手Q44区-疾风之箭"
    },
    {
        "id": 45,
        "value": "手Q45区-寒冰箭雨"
    },
    {
        "id": 46,
        "value": "手Q46区-惩戒射击"
    },
    {
        "id": 47,
        "value": "手Q47区-勇气意志"
    },
    {
        "id": 48,
        "value": "手Q48区-苍破烈斩"
    },
    {
        "id": 49,
        "value": "手Q49区-突进之刃"
    },
    {
        "id": 50,
        "value": "手Q50区-绽放刀锋"
    },
    {
        "id": 51,
        "value": "手Q51区-残月利刃"
    },
    {
        "id": 52,
        "value": "手Q52区-月光剑舞"
    },
    {
        "id": 53,
        "value": "手Q53区-灼热之月"
    },
    {
        "id": 54,
        "value": "手Q54区-血月之弑"
    },
    {
        "id": 55,
        "value": "手Q55区-疯狂弹幕"
    },
    {
        "id": 56,
        "value": "手Q56区-加农派对"
    },
    {
        "id": 57,
        "value": "手Q57区-机关迷城"
    },
    {
        "id": 58,
        "value": "手Q58区-青莲剑歌"
    },
    {
        "id": 59,
        "value": "手Q59区-神来之笔"
    },
    {
        "id": 60,
        "value": "手Q60区-逆袭之刃"
    },
    {
        "id": 61,
        "value": "手Q61区-不羁豪气"
    },
    {
        "id": 62,
        "value": "手Q62区-搏击拳套"
    },
    {
        "id": 63,
        "value": "手Q63区-吸血之镰"
    },
    {
        "id": 64,
        "value": "手Q64区-秘义之剑"
    },
    {
        "id": 65,
        "value": "手Q65区-风暴巨剑"
    },
    {
        "id": 66,
        "value": "手Q66区-日蚀之锤"
    },
    {
        "id": 67,
        "value": "手Q67区-狂暴双刃"
    },
    {
        "id": 68,
        "value": "手Q68区-凶残之力"
    },
    {
        "id": 69,
        "value": "手Q69区-破魔之刀"
    },
    {
        "id": 70,
        "value": "手Q70区-破灭君主"
    },
    {
        "id": 71,
        "value": "手Q71区-名刀正宗"
    },
    {
        "id": 72,
        "value": "手Q72区-泣血之刃"
    },
    {
        "id": 73,
        "value": "手Q73区-无尽刀锋"
    },
    {
        "id": 74,
        "value": "手Q74区-三圣之力"
    },
    {
        "id": 75,
        "value": "手Q75区-黑色战斧"
    },
    {
        "id": 76,
        "value": "手Q76区-影刃破军"
    },
    {
        "id": 77,
        "value": "手Q77区-咒术典籍"
    },
    {
        "id": 78,
        "value": "手Q78区-炼金护符"
    },
    {
        "id": 79,
        "value": "手Q79区-圣者法典"
    },
    {
        "id": 80,
        "value": "手Q80区-灵魂长卷"
    },
    {
        "id": 81,
        "value": "手Q81区-血族之书"
    },
    {
        "id": 82,
        "value": "手Q82区-光辉之剑"
    },
    {
        "id": 83,
        "value": "手Q83区-小丑面罩"
    },
    {
        "id": 84,
        "value": "手Q84区-进化水晶"
    },
    {
        "id": 85,
        "value": "手Q85区-炽热之拥"
    },
    {
        "id": 86,
        "value": "手Q86区-虚无法杖"
    },
    {
        "id": 87,
        "value": "手Q87区-回响之杖"
    },
    {
        "id": 88,
        "value": "手Q88区-冰霜法杖"
    },
    {
        "id": 89,
        "value": "手Q89区-奇迹幻视"
    },
    {
        "id": 90,
        "value": "手Q90区-巫术法杖"
    },
    {
        "id": 91,
        "value": "手Q91区-时之预言"
    },
    {
        "id": 92,
        "value": "手Q92区-贤者之书"
    },
    {
        "id": 93,
        "value": "手Q93区-海蓝宝石"
    },
    {
        "id": 94,
        "value": "手Q94区-绯红玛瑙"
    },
    {
        "id": 95,
        "value": "手Q95区-抗魔披风"
    },
    {
        "id": 96,
        "value": "手Q96区-生命宝珠"
    },
    {
        "id": 97,
        "value": "手Q97区-杀戮之甲"
    },
    {
        "id": 98,
        "value": "手Q98区-力量腰带"
    },
    {
        "id": 99,
        "value": "手Q99区-熔炼之心"
    },
    {
        "id": 100,
        "value": "手Q100区-神隐斗篷"
    },
    {
        "id": 101,
        "value": "手Q101区-雪山圆盾"
    },
    {
        "id": 102,
        "value": "手Q102区-军团荣耀"
    },
    {
        "id": 103,
        "value": "手Q103区-反伤刺甲"
    },
    {
        "id": 104,
        "value": "手Q104区-红莲斗篷"
    },
    {
        "id": 105,
        "value": "手Q105区-霸者重装"
    },
    {
        "id": 106,
        "value": "手Q106区-敬畏虚空"
    },
    {
        "id": 107,
        "value": "手Q107区-振兴之铠"
    },
    {
        "id": 108,
        "value": "手Q108区-魔女面纱"
    },
    {
        "id": 109,
        "value": "手Q109区-寒冰之心"
    },
    {
        "id": 110,
        "value": "手Q110区-贤者庇护"
    },
    {
        "id": 111,
        "value": "手Q111区-暴烈之甲"
    },
    {
        "id": 112,
        "value": "手Q112区-神速之靴"
    },
    {
        "id": 113,
        "value": "手Q113区-影忍之足"
    },
    {
        "id": 114,
        "value": "手Q114区-冷静抵抗"
    },
    {
        "id": 115,
        "value": "手Q115区-急速秘法"
    },
    {
        "id": 116,
        "value": "手Q116区-召唤战场"
    },
    {
        "id": 117,
        "value": "手Q117区-通天之塔"
    },
    {
        "id": 118,
        "value": "手Q118区-疾步之靴"
    },
    {
        "id": 119,
        "value": "手Q119区-狩猎宽刃"
    },
    {
        "id": 120,
        "value": "手Q120区-符文大剑"
    },
    {
        "id": 121,
        "value": "手Q121区-巨人之握"
    },
    {
        "id": 122,
        "value": "手Q122区-贪婪之噬"
    },
    {
        "id": 123,
        "value": "手Q123区-追击刀锋"
    },
    {
        "id": 124,
        "value": "手Q124区-巡守利斧"
    },
    {
        "id": 125,
        "value": "手Q125区-游击弯刀"
    },
    {
        "id": 126,
        "value": "手Q126区-幽灵疾步"
    },
    {
        "id": 127,
        "value": "手Q127区-心灵治疗"
    },
    {
        "id": 128,
        "value": "手Q128区-重力眩晕"
    },
    {
        "id": 129,
        "value": "手Q129区-自然净化"
    },
    {
        "id": 130,
        "value": "手Q130区-振奋冲击"
    },
    {
        "id": 131,
        "value": "手Q131区-圣骑王者"
    },
    {
        "id": 132,
        "value": "手Q132区-精灵冰弓"
    },
    {
        "id": 133,
        "value": "手Q133区-魔法大师"
    },
    {
        "id": 134,
        "value": "手Q134区-地狱岩魂"
    },
    {
        "id": 135,
        "value": "手Q135区-万圣前夜"
    },
    {
        "id": 136,
        "value": "手Q136区-忍者炎影"
    },
    {
        "id": 137,
        "value": "手Q137区-未来纪元"
    },
    {
        "id": 138,
        "value": "手Q138区-皇家上将"
    },
    {
        "id": 139,
        "value": "手Q139区-仁德义枪"
    },
    {
        "id": 140,
        "value": "手Q140区-禁血狂兽"
    },
    {
        "id": 141,
        "value": "手Q141区-一骑当千"
    },
    {
        "id": 142,
        "value": "手Q142区-单刀赴会"
    },
    {
        "id": 143,
        "value": "手Q143区-青龙偃月"
    },
    {
        "id": 144,
        "value": "手Q144区-侠客行"
    },
    {
        "id": 145,
        "value": "手Q145区-将进酒"
    },
    {
        "id": 146,
        "value": "手Q146区-强化霰弹"
    },
    {
        "id": 147,
        "value": "手Q147区-双重射击"
    },
    {
        "id": 148,
        "value": "手Q148区-震荡射击"
    },
    {
        "id": 149,
        "value": "手Q149区-万象初新"
    },
    {
        "id": 150,
        "value": "手Q150区-黑暗潜能"
    },
    {
        "id": 151,
        "value": "手Q151区-画地为牢"
    },
    {
        "id": 152,
        "value": "手Q152区-狂意杀戮"
    },
    {
        "id": 153,
        "value": "手Q153区-守护机关"
    },
    {
        "id": 154,
        "value": "手Q154区-崩裂践踏"
    },
    {
        "id": 155,
        "value": "手Q155区-狂兽血性"
    },
    {
        "id": 156,
        "value": "手Q156区-饕餮血统"
    },
    {
        "id": 157,
        "value": "手Q157区-方天画斩"
    },
    {
        "id": 158,
        "value": "手Q158区-贪狼之握"
    },
    {
        "id": 159,
        "value": "手Q159区-魔神降世"
    },
    {
        "id": 160,
        "value": "手Q160区-大圣神威"
    },
    {
        "id": 161,
        "value": "手Q161区-七十二变"
    },
    {
        "id": 162,
        "value": "手Q162区-斗战冲锋"
    },
    {
        "id": 163,
        "value": "手Q163区-如意金箍"
    },
    {
        "id": 164,
        "value": "手Q164区-战争践踏"
    },
    {
        "id": 165,
        "value": "手Q165区-大地震撼"
    },
    {
        "id": 166,
        "value": "手Q166区-横行霸道"
    },
    {
        "id": 167,
        "value": "手Q167区-野性意志"
    },
    {
        "id": 168,
        "value": "手Q168区-语花印"
    },
    {
        "id": 169,
        "value": "手Q169区-落红雨"
    },
    {
        "id": 170,
        "value": "手Q170区-缘心结"
    },
    {
        "id": 171,
        "value": "手Q171区-绽风华"
    },
    {
        "id": 172,
        "value": "手Q172区-齐天大圣"
    },
    {
        "id": 173,
        "value": "手Q173区-精英酋长"
    },
    {
        "id": 174,
        "value": "手Q174区-半神之弓"
    },
    {
        "id": 175,
        "value": "手Q175区-摘星楼"
    },
    {
        "id": 176,
        "value": "手Q176区-王者峡谷"
    },
    {
        "id": 177,
        "value": "手Q177区-长平战场"
    },
    {
        "id": 178,
        "value": "手Q178区-海洋之心"
    },
    {
        "id": 179,
        "value": "手Q179区-白衣执事"
    },
    {
        "id": 180,
        "value": "手Q180区-天鹅之梦"
    },
    {
        "id": 181,
        "value": "手Q181区-大魔术师"
    },
    {
        "id": 182,
        "value": "手Q182区-职棒王牌"
    },
    {
        "id": 183,
        "value": "手Q183区-天魔缭乱"
    },
    {
        "id": 184,
        "value": "手Q184区-紫霞仙子"
    },
    {
        "id": 185,
        "value": "手Q185区-教廷特使"
    },
    {
        "id": 186,
        "value": "手Q186区-我是歌手"
    },
    {
        "id": 187,
        "value": "手Q187区-天堂福音"
    },
    {
        "id": 188,
        "value": "手Q188区-波斯王子"
    },
    {
        "id": 189,
        "value": "手Q189区-荒野镖客"
    },
    {
        "id": 190,
        "value": "手Q190区-西部镖客"
    },
    {
        "id": 191,
        "value": "手Q191区-荣耀王者"
    },
    {
        "id": 192,
        "value": "手Q192区-哥特玫瑰"
    },
    {
        "id": 193,
        "value": "手Q193区-绯红之刃"
    },
    {
        "id": 194,
        "value": "手Q194区-鬼之武者"
    },
    {
        "id": 195,
        "value": "手Q195区-地狱之火"
    },
    {
        "id": 196,
        "value": "手Q196区-天启骑士"
    },
    {
        "id": 197,
        "value": "手Q197区-花好人间"
    },
    {
        "id": 198,
        "value": "手Q198区-大秦宣后"
    },
    {
        "id": 199,
        "value": "手Q199区-万事如意"
    },
    {
        "id": 200,
        "value": "手Q200区-龙腾万里"
    },
    {
        "id": 201,
        "value": "手Q201区-密探之力"
    },
    {
        "id": 202,
        "value": "手Q202区-谍影重重"
    },
    {
        "id": 203,
        "value": "手Q203区-无间刃锋"
    },
    {
        "id": 204,
        "value": "手Q204区-制裁仪式"
    },
    {
        "id": 205,
        "value": "手Q205区-虚空吞没"
    },
    {
        "id": 206,
        "value": "手Q206区-湮灭之锁"
    },
    {
        "id": 207,
        "value": "手Q207区-轮回吞噬"
    },
    {
        "id": 208,
        "value": "手Q208区-飞翔龙炎"
    },
    {
        "id": 209,
        "value": "手Q209区-花蝶之扇"
    },
    {
        "id": 210,
        "value": "手Q210区-必杀忍蜂"
    },
    {
        "id": 211,
        "value": "手Q211区-流刀舞术"
    },
    {
        "id": 212,
        "value": "手Q212区-飞鹰攻击"
    },
    {
        "id": 213,
        "value": "手Q213区-清风之刃"
    },
    {
        "id": 214,
        "value": "手Q214区-飞鹰急袭"
    },
    {
        "id": 215,
        "value": "手Q215区-大唐传奇"
    },
    {
        "id": 216,
        "value": "手Q216区-桃园结义"
    },
    {
        "id": 217,
        "value": "手Q217区-燎原火"
    },
    {
        "id": 218,
        "value": "手Q218区-血之咆哮"
    },
    {
        "id": 219,
        "value": "手Q219区-天之劫"
    },
    {
        "id": 220,
        "value": "手Q220区-不死之王"
    },
    {
        "id": 221,
        "value": "手Q221区-荆棘之心"
    },
    {
        "id": 222,
        "value": "手Q222区-魔女斗篷"
    },
    {
        "id": 223,
        "value": "手Q223区-觉醒水晶"
    },
    {
        "id": 224,
        "value": "手Q224区-新月残像"
    },
    {
        "id": 225,
        "value": "手Q225区-神圣心石"
    },
    {
        "id": 226,
        "value": "手Q226区-死海文书"
    },
    {
        "id": 227,
        "value": "手Q227区-王的铁面"
    },
    {
        "id": 228,
        "value": "手Q228区-王城密探"
    },
    {
        "id": 229,
        "value": "手Q229区-虚灵城判"
    },
    {
        "id": 230,
        "value": "手Q230区-鹰之守护"
    },
    {
        "id": 231,
        "value": "手Q231区-明媚烈焰"
    },
    {
        "id": 232,
        "value": "手Q232区-地府判官"
    },
    {
        "id": 233,
        "value": "手Q233区-特种小队"
    },
    {
        "id": 234,
        "value": "手Q234区-狮心王"
    },
    {
        "id": 235,
        "value": "手Q235区-千年之狐"
    },
    {
        "id": 236,
        "value": "手Q236区-灾厄尽头"
    },
    {
        "id": 237,
        "value": "手Q237区-稷下战场"
    },
    {
        "id": 238,
        "value": "手Q238区-传送之扉"
    },
    {
        "id": 239,
        "value": "手Q239区-杀戮回忆"
    },
    {
        "id": 240,
        "value": "手Q240区-机关迷城"
    },
    {
        "id": 241,
        "value": "手Q241区-隐秘牢笼"
    },
    {
        "id": 242,
        "value": "手Q242区-意志传承"
    },
    {
        "id": 243,
        "value": "手Q243区-时光倒流"
    },
    {
        "id": 244,
        "value": "手Q244区-长平攻防"
    },
    {
        "id": 245,
        "value": "手Q245区-血浓于血"
    },
    {
        "id": 246,
        "value": "手Q246区-魔道探索"
    },
    {
        "id": 247,
        "value": "手Q247区-魔道信仰"
    },
    {
        "id": 248,
        "value": "手Q248区-博学魔道"
    },
    {
        "id": 249,
        "value": "手Q249区-王族血统"
    },
    {
        "id": 250,
        "value": "手Q250区-天潢贵胄"
    },
    {
        "id": 251,
        "value": "手Q251区-苍狼末裔"
    },
    {
        "id": 252,
        "value": "手Q252区-根源之目"
    },
    {
        "id": 253,
        "value": "手Q253区-至高创世"
    },
    {
        "id": 254,
        "value": "手Q254区-桀骜炎枪"
    },
    {
        "id": 255,
        "value": "手Q255区-淬命双剑"
    },
    {
        "id": 256,
        "value": "手Q256区-圣域余晖"
    },
    {
        "id": 257,
        "value": "手Q257区-天籁弦音"
    },
    {
        "id": 258,
        "value": "手Q258区-炼金大师"
    },
    {
        "id": 259,
        "value": "手Q259区-噬灭日蚀"
    },
    {
        "id": 260,
        "value": "手Q260区-万物有灵"
    },
    {
        "id": 261,
        "value": "手Q261区-绝代智谋"
    },
    {
        "id": 262,
        "value": "手Q262区-燃魂重炮"
    },
    {
        "id": 263,
        "value": "手Q263区-追击潜能"
    },
    {
        "id": 264,
        "value": "手Q264区-警戒地雷"
    },
    {
        "id": 265,
        "value": "手Q265区-重装炮台"
    },
    {
        "id": 266,
        "value": "手Q266区-玄微之灵"
    },
    {
        "id": 267,
        "value": "手Q267区-纵横兵法"
    },
    {
        "id": 268,
        "value": "手Q268区-先知奇谋"
    },
    {
        "id": 269,
        "value": "手Q269区-气数终焉"
    },
    {
        "id": 270,
        "value": "手Q270区-太古雷霆"
    },
    {
        "id": 271,
        "value": "手Q271区-全能宗师"
    },
    {
        "id": 272,
        "value": "手Q272区-造化敕令"
    },
    {
        "id": 273,
        "value": "手Q273区-制裁神谕"
    },
    {
        "id": 274,
        "value": "手Q274区-炙炼火种"
    },
    {
        "id": 275,
        "value": "手Q275区-火焰尖枪"
    },
    {
        "id": 276,
        "value": "手Q276区-混天绫束"
    },
    {
        "id": 277,
        "value": "手Q277区-乾坤天降"
    },
    {
        "id": 278,
        "value": "手Q278区-提线傀儡"
    },
    {
        "id": 279,
        "value": "手Q279区-虚妄破灭"
    },
    {
        "id": 280,
        "value": "手Q280区-根源之目"
    },
    {
        "id": 281,
        "value": "手Q281区-百兽陷阱"
    },
    {
        "id": 282,
        "value": "手Q282区-可汗狂猎"
    },
    {
        "id": 283,
        "value": "手Q283区-树神护佑"
    },
    {
        "id": 284,
        "value": "手Q284区-楚歌起"
    },
    {
        "id": 285,
        "value": "手Q285区-大风来"
    },
    {
        "id": 286,
        "value": "手Q286区-阵前舞"
    },
    {
        "id": 287,
        "value": "手Q287区-密探谛听"
    },
    {
        "id": 288,
        "value": "手Q288区-秘剑胧刀"
    },
    {
        "id": 289,
        "value": "手Q289区-神梦一刀"
    },
    {
        "id": 290,
        "value": "手Q290区-燕返居合"
    },
    {
        "id": 291,
        "value": "手Q291区-华丽左轮"
    },
    {
        "id": 292,
        "value": "手Q292区-漫游之枪"
    },
    {
        "id": 293,
        "value": "手Q293区-狂热弹幕"
    },
    {
        "id": 294,
        "value": "手Q294区-真神觉醒"
    },
    {
        "id": 295,
        "value": "手Q295区-神圣进军"
    },
    {
        "id": 296,
        "value": "手Q296区-贯穿之枪"
    },
    {
        "id": 297,
        "value": "手Q297区-敬畏圣盾"
    },
    {
        "id": 298,
        "value": "手Q298区-奔狼纹章"
    },
    {
        "id": 299,
        "value": "手Q299区-不祥征兆"
    },
    {
        "id": 300,
        "value": "手Q300区-梦魇之牙"
    },
    {
        "id": 301,
        "value": "手Q301区-惊鸿之笔"
    },
    {
        "id": 302,
        "value": "手Q302区-隐龙之影"
    },
    {
        "id": 303,
        "value": "手Q303区-爆炸心跳"
    },
    {
        "id": 304,
        "value": "手Q304区-节奏热浪"
    },
    {
        "id": 305,
        "value": "手Q305区-踏雪寻梅"
    },
    {
        "id": 306,
        "value": "手Q306区-虎啸风生"
    },
    {
        "id": 307,
        "value": "手Q307区-天元之弈"
    },
    {
        "id": 308,
        "value": "手Q308区-霓裳风华"
    },
    {
        "id": 309,
        "value": "手Q309区-孤鹜断霞"
    },
    {
        "id": 310,
        "value": "手Q310区-寂灭之心"
    },
    {
        "id": 311,
        "value": "手Q311区-无尽之盾"
    },
    {
        "id": 312,
        "value": "手Q312区-灵魂卜劫"
    },
    {
        "id": 313,
        "value": "手Q313区-海之征途"
    },
    {
        "id": 314,
        "value": "手Q314区-曙光守护"
    },
    {
        "id": 315,
        "value": "手Q315区-云端筑梦"
    },
    {
        "id": 316,
        "value": "手Q316区-千机万变"
    },
    {
        "id": 317,
        "value": "手Q317区-特工魅影"
    },
    {
        "id": 318,
        "value": "手Q318区-心灵骇客"
    },
    {
        "id": 319,
        "value": "手Q319区-无乡幽灵"
    },
    {
        "id": 320,
        "value": "手Q320区-幻乐之宴"
    },
    {
        "id": 321,
        "value": "手Q321区-一夫当关"
    },
    {
        "id": 322,
        "value": "手Q322区-静默之语"
    },
    {
        "id": 323,
        "value": "手Q323区-利刃藏锋"
    },
    {
        "id": 324,
        "value": "手Q324区-天地化盾"
    },
    {
        "id": 325,
        "value": "手Q325区-幽影之咬"
    },
    {
        "id": 326,
        "value": "手Q326区-笔走龙蛇"
    },
    {
        "id": 327,
        "value": "手Q327区-劈风斩浪"
    },
    {
        "id": 328,
        "value": "手Q328区-善恶诊断"
    },
    {
        "id": 329,
        "value": "手Q329区-无畏战车"
    },
    {
        "id": 330,
        "value": "手Q330区-灼日之矢"
    },
    {
        "id": 331,
        "value": "手Q331区-碎星之锤"
    },
    {
        "id": 332,
        "value": "手Q332区-末世赤瞳"
    },
    {
        "id": 333,
        "value": "手Q333区-凤鸣指环"
    },
    {
        "id": 334,
        "value": "手Q334区-冰痕之握"
    },
    {
        "id": 335,
        "value": "手Q335区-日冕时刻"
    },
    {
        "id": 336,
        "value": "手Q336区-宗师之力"
    },
    {
        "id": 337,
        "value": "手Q337区-魅影面罩"
    },
    {
        "id": 338,
        "value": "手Q338区-风灵纹章"
    },
    {
        "id": 339,
        "value": "手Q339区-逐日之弓"
    },
    {
        "id": 340,
        "value": "手Q340区-破碎圣杯"
    },
    {
        "id": 341,
        "value": "手Q341区-狂热序章"
    },
    {
        "id": 342,
        "value": "手Q342区-辉煌指引"
    },
    {
        "id": 343,
        "value": "手Q343区-东风破袭"
    },
    {
        "id": 344,
        "value": "手Q344区-比翼同心"
    },
    {
        "id": 345,
        "value": "手Q345区-决断之桥"
    },
    {
        "id": 346,
        "value": "手Q346区-落日余晖"
    },
    {
        "id": 347,
        "value": "手Q347区-荒芜之域"
    },
    {
        "id": 348,
        "value": "手Q348区-海潮怒吼"
    },
    {
        "id": 349,
        "value": "手Q349区-浩劫磁场"
    },
    {
        "id": 350,
        "value": "手Q350区-强袭风暴"
    },
    {
        "id": 351,
        "value": "手Q351区-东风祭坛"
    },
    {
        "id": 352,
        "value": "手Q352区-勇士之地"
    },
    {
        "id": 353,
        "value": "手Q353区-金庭遗梦"
    },
    {
        "id": 354,
        "value": "手Q354区-雁帐美酒"
    },
    {
        "id": 355,
        "value": "手Q355区-冰原苍狼"
    },
    {
        "id": 356,
        "value": "手Q356区-大明宫词"
    },
    {
        "id": 357,
        "value": "手Q357区-河洛一方"
    },
    {
        "id": 358,
        "value": "手Q358区-千窟之城"
    },
    {
        "id": 359,
        "value": "手Q359区-京都来客"
    },
    {
        "id": 360,
        "value": "手Q360区-血族巢穴"
    },
    {
        "id": 361,
        "value": "手Q361区-鹰眼追击"
    },
    {
        "id": 362,
        "value": "手Q362区-草丛隐匿"
    },
    {
        "id": 363,
        "value": "手Q363区-宿命传承"
    },
    {
        "id": 364,
        "value": "手Q364区-野兽之痕"
    },
    {
        "id": 365,
        "value": "手Q365区-自然调和"
    },
    {
        "id": 366,
        "value": "手Q366区-浮生虚空"
    },
    {
        "id": 367,
        "value": "手Q367区-玲珑心眼"
    },
    {
        "id": 368,
        "value": "手Q368区-贪婪罪名"
    },
    {
        "id": 369,
        "value": "手Q369区-异变领土"
    },
    {
        "id": 370,
        "value": "手Q370区-心为祸源"
    },
    {
        "id": 371,
        "value": "手Q371区-灵魂乐师"
    },
    {
        "id": 372,
        "value": "手Q372区-月光女神"
    },
    {
        "id": 373,
        "value": "手Q373区-玩偶法师"
    },
    {
        "id": 374,
        "value": "手Q374区-牡丹方士"
    },
    {
        "id": 375,
        "value": "手Q375区-爆弹怪猫"
    },
    {
        "id": 376,
        "value": "手Q376区-长安秘使"
    },
    {
        "id": 377,
        "value": "手Q377区-白发名将"
    },
    {
        "id": 378,
        "value": "手Q378区-逍遥书生"
    },
    {
        "id": 379,
        "value": "手Q379区-寻宝奇侠"
    },
    {
        "id": 380,
        "value": "手Q380区-王者出征"
    },
    {
        "id": 381,
        "value": "手Q381区-献祭之名"
    },
    {
        "id": 382,
        "value": "手Q382区-枭雄纷争"
    },
    {
        "id": 383,
        "value": "手Q383区-长生秘药"
    },
    {
        "id": 384,
        "value": "手Q384区-彼岸冥想"
    },
    {
        "id": 385,
        "value": "手Q385区-灵山之巅"
    },
    {
        "id": 386,
        "value": "手Q386区-群英荟萃"
    },
    {
        "id": 387,
        "value": "手Q387区-芳心狩猎"
    },
    {
        "id": 388,
        "value": "手Q388区-霸者无疆"
    },
    {
        "id": 389,
        "value": "手Q389区-梦境回声"
    },
    {
        "id": 390,
        "value": "手Q390区-敬畏存心"
    },
    {
        "id": 391,
        "value": "手Q391区-圣殿骑士"
    },
    {
        "id": 392,
        "value": "手Q392区-忍之武者"
    },
    {
        "id": 393,
        "value": "手Q393区-暗影伯爵"
    },
    {
        "id": 394,
        "value": "手Q394区-奇迹天使"
    },
    {
        "id": 395,
        "value": "手Q395区-虚妄神明"
    },
    {
        "id": 396,
        "value": "手Q396区-海的新娘"
    },
    {
        "id": 397,
        "value": "手Q397区-守灯旅客"
    },
    {
        "id": 398,
        "value": "手Q398区-金刚丽人"
    },
    {
        "id": 399,
        "value": "手Q399区-恶德怪医"
    },
    {
        "id": 400,
        "value": "手Q400区-时间之子"
    },
    {
        "id": 401,
        "value": "手Q401区-长虹贯日"
    },
    {
        "id": 402,
        "value": "手Q402区-三足鼎立"
    },
    {
        "id": 403,
        "value": "手Q403区-三顾茅庐"
    },
    {
        "id": 404,
        "value": "手Q404区-铁索连环"
    },
    {
        "id": 405,
        "value": "手Q405区-魏武挥鞭"
    },
    {
        "id": 406,
        "value": "手Q406区-华灯初上"
    },
    {
        "id": 407,
        "value": "手Q407区-顾曲周郎"
    },
    {
        "id": 408,
        "value": "手Q408区-星罗棋布"
    },
    {
        "id": 409,
        "value": "手Q409区-绮年玉貌"
    },
    {
        "id": 410,
        "value": "手Q410区-飞阁流丹"
    },
    {
        "id": 411,
        "value": "手Q411区-弯弓落月"
    },
    {
        "id": 412,
        "value": "手Q412区-巧夺天工"
    },
    {
        "id": 413,
        "value": "手Q413区-锦衣夜行"
    },
    {
        "id": 414,
        "value": "手Q414区-烟波浩渺"
    },
    {
        "id": 415,
        "value": "手Q415区-雷霆万钧"
    },
    {
        "id": 416,
        "value": "手Q416区-风云乍起"
    },
    {
        "id": 417,
        "value": "手Q417区-不夜长安"
    },
    {
        "id": 418,
        "value": "手Q418区-百战神将"
    },
    {
        "id": 419,
        "value": "手Q419区-琴瑟和鸣"
    },
    {
        "id": 420,
        "value": "手Q420区-无字萧墙"
    },
    {
        "id": 421,
        "value": "手Q421区-曲水流觞"
    },
    {
        "id": 422,
        "value": "手Q422区-惊鸿一瞥"
    },
    {
        "id": 423,
        "value": "手Q423区-一叶孤舟"
    },
    {
        "id": 424,
        "value": "手Q424区-艨艟战船"
    },
    {
        "id": 425,
        "value": "手Q425区-天工开物"
    },
    {
        "id": 426,
        "value": "手Q426区-仗剑四方"
    },
    {
        "id": 427,
        "value": "手Q427区-珍珑棋局"
    },
    {
        "id": 428,
        "value": "手Q428区-雁行之阵"
    },
    {
        "id": 429,
        "value": "手Q429区-疑决卦"
    },
    {
        "id": 430,
        "value": "手Q430区-醍醐杖"
    },
    {
        "id": 431,
        "value": "手Q431区-神枪掠火"
    },
    {
        "id": 432,
        "value": "手Q432区-迅光破魔"
    },
    {
        "id": 433,
        "value": "手Q433区-游云惊龙"
    },
    {
        "id": 434,
        "value": "手Q434区-飞白藏锋"
    },
    {
        "id": 435,
        "value": "手Q435区-旋舞轻语"
    },
    {
        "id": 436,
        "value": "手Q436区-断空一刀"
    },
    {
        "id": 437,
        "value": "手Q437区-正义使命"
    },
    {
        "id": 438,
        "value": "手Q438区-天书无言"
    },
    {
        "id": 439,
        "value": "手Q439区-全息碎影"
    },
    {
        "id": 440,
        "value": "手Q440区-风刃急袭"
    },
    {
        "id": 441,
        "value": "手Q441区-飞火流萤"
    },
    {
        "id": 442,
        "value": "手Q442区-傲雪凌霜"
    },
    {
        "id": 443,
        "value": "手Q443区-燎原烈火"
    },
    {
        "id": 444,
        "value": "手Q444区-山林奇缘"
    },
    {
        "id": 445,
        "value": "手Q445区-电玩高手"
    },
    {
        "id": 446,
        "value": "手Q446区-龙战玄黄"
    },
    {
        "id": 447,
        "value": "手Q447区-光霁月明"
    },
    {
        "id": 448,
        "value": "手Q448区-赤影无双"
    },
    {
        "id": 449,
        "value": "手Q449区-信步漫游"
    },
    {
        "id": 450,
        "value": "手Q450区-龙鼓争鸣"
    },
    {
        "id": 0,
        "value": "手Q王者抢先服"
    },
]
export { configIos, configA }
